export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Roman.0247694e.woff";